var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',[_c('b-button',{style:({ background: _vm.color, borderColor: _vm.color, color: 'black' }),attrs:{"variant":_vm.changeColor}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }